import React, { useEffect, useState } from 'react'
import { GetDetail, Post, Update } from '../../web_api/api'
import { Link, useLocation } from 'react-router-dom'
import Swal from 'sweetalert2'
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { FaImages } from "react-icons/fa";
export default function BannerCreate() {
    const location = useLocation()
    const ID = location.pathname.split('/')[2]
    const [image, setImage] = useState('')
    const [imageData, setImageData] = useState([])
    const [imageTempArr, setImageTempArr] = useState([])

    const ImageSaveSection = (e) => {
        setImage(e.target.files[0])
    } // to save image from onChange

    console.log(image, 'create')
    const create = async () => {
        const formData = new FormData()

        formData.append('banners', image ? image : imageData.imgUrl)


        if (!image) {
            Swal.fire({
                title: 'Need Image!',
                text: 'Try again!',
                icon: 'error',
                // showCancelButton: true,

                showConfirmButton: false,
                timer: 2000
            })
        } else {
            await Update('/banner-photo/', ID, formData, { headers: { 'Content-Type': 'multipart/form-data' } })

        }

    }

    useEffect(() => {
        const getList = async () => {
            const res = await GetDetail('banner-photo/', ID)
            // console.log(res.data, 'res')
            setImageData(res.data)
        }
        getList()
    }, [])
    return (
        <div>

            <div className='border-1 border-info rounded-1 border p-3 mt-2'>
                <div className=''>
                    <label for='#tn' className={(image.length === 0) ? 'text-red' : ''}>Image </label>
                    <input type='file' id='tn' className='form-control' onChange={(e) => ImageSaveSection(e)} />
                </div>

                <div className='col-3 '>
                    {/* To view fullscreen for image */}
                    <PhotoProvider>
                        <PhotoView key={imageData._id} src={"http://192.168.1.5:9090/uploads" + imageData.imgUrl}>
                            <abbr title='Click View' className={imageData.imgUrl ? 'text-blue' : ''}>
                                <FaImages style={{ width: '50px', height: '100px' }} />
                            </abbr>
                        </PhotoView>
                    </PhotoProvider >

                </div>

            </div>
            {/* Footer Button */}
            <div className='mt-3 text-start '>
                <Link to='/treatment-dashboard' className='btn btn-sm btn-default text-red rounded-2  ' >Cancel</Link>
                <button className='btn btn-sm btn-success rounded-2 ml-2 ' onClick={create}>Update</button>
            </div>
        </div>
    )
}
